import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FORM_DATA } from 'src/app/models/cleaver_hr_form_model';
import { TestService } from 'src/app/services/test.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cleaver-hf-form',
  templateUrl: './cleaver-hf-form.component.html',
  styleUrls: ['./cleaver-hf-form.component.css']
})
export class CleaverHfFormComponent implements OnInit {

  @Input() test: any;
  @Output() saved: EventEmitter<string> = new EventEmitter();
  public hrFormData = FORM_DATA;
  public values: number[] = [];

  constructor(
    private testService: TestService
  ) { }

  ngOnInit(): void {
    if (this.test.cleaverHfResult.length == 0) {
      this.hrFormData.map((item, i) => {
        this.values[i] = 1; 
      })
    }
    else {
      this.values = this.test.cleaverHfResult;
    }
    this.checkMaxMin();
  }

  checkMaxMin(){
    let optionsWith5 = 0;
    let max = 5;
    let min = 1;
    setTimeout(() => {
      this.values = this.values.map(value => {
        if (value === 5) {
          optionsWith5++;
        }
        if (optionsWith5 > 5) {
          return 4;
        }
        if (value > max) {
          return max;
        } else if (value < min) {
          return min;
        }
        return value;
      })
    }, 100)
  }

  update(){
    this.testService.updateTest({
      _id: this.test._id,
      cleaverHfResult: this.values
    }).subscribe(
      resp => {
        Swal.fire({
          icon: 'success',
          text: 'Formulario guardado correctamente',
        })
        this.saved.emit('ok');
      }
    )
  }

}
